// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_wrapper__GGP5F","body":"wrapper_body__N1wIt","title":"wrapper_title__THWxj","icon":"wrapper_icon__UvtFe"};